<template>
    <li class="nav-menu-item" :data-disabled="disabled">
        <span v-if="disabled" class="nav-menu-item__content disabled">
            <slot/>
        </span>

        <a v-else :href="href" class="nav-menu-item__content">
            <slot/>
        </a>
    </li>
</template>

<script>
    import VueTypes from "vue-types"

    export default {
        props: {
            href: VueTypes.string.def("/"),
            disabled: VueTypes.bool.def(false),
        },
    }
</script>

<style lang="scss" scoped>
    @use "~@scss/components/NavItem" as *;
</style>